export const CONTACT_EMAIL = "hello@nostos.in";
export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const FOUNDING_CAP = 200;
export const LAUNCH_YES_GOAL = 200;
